export enum PoolStatusEnum {
  LIVE = 'LIVE',
  ENDED = 'ENDED',
}
export interface PoolStatus {
  LIVE: PoolStatusEnum.LIVE;
  ENDED: PoolStatusEnum.ENDED;
}
